import React from 'react'
import styled from 'styled-components'

import {
  AIRPORT_TRANSFER_OPTIONS,
  ALTERNATIVE_UNIT_TYPE_CONSIDERED_OPTIONS,
  CANCELLATION_POLICY_OPTIONS,
  COMMUTE_TIME_OPTIONS,
  IN_HOUSE_CANCELLATION_OPTIONS,
  MONTH_TO_MONTH_LEASE_OPTIONS,
  REQUEST_HOUSEKEEPING_OPTIONS,
  TYPE_OF_COMMUTE_OPTIONS,
} from '@/constants/hor'
import { errorMessages } from '@/constants/messages'
import { useIsRiverside } from '@/hooks/useIsRiverside'
import { Select } from '@/UIkit/Select'
import { TextArea } from '@/UIkit/TextArea'
import { TextInput } from '@/UIkit/TextInput'
import { ToggleAndDescription } from '@/UIkit/ToggleAndDescription'

import { useOptionalInformationFormSection } from './hooks'

import { SectionTitle } from '../../styles'

export const FormSection = styled.div`
  margin-bottom: 2.5rem;
  row-gap: 1.5rem;
  display: flex;
  flex-direction: column;
`

export const OptionalInformationFormSection = () => {
  const {
    airportTransferChecked,
    control,
    errors,
    register,
    sortOptions,
    isAlternativeUnitTypeValid,
    shouldShowWelcomePack,
  } = useOptionalInformationFormSection()
  const { isRiverside } = useIsRiverside()

  return (
    <FormSection>
      <SectionTitle>Optional Preferences</SectionTitle>
      <Select
        isClearable
        control={control}
        rules={{
          validate: isAlternativeUnitTypeValid,
        }}
        error={errors.alternativeUnitTypeConsidered}
        name="alternativeUnitTypeConsidered"
        options={ALTERNATIVE_UNIT_TYPE_CONSIDERED_OPTIONS}
        label="Alternative Unit Type Considered"
      />
      <Select
        isClearable
        control={control}
        name="requestedCleaningType"
        options={REQUEST_HOUSEKEEPING_OPTIONS}
        label="Housekeeping Required"
      />
      <Select
        isClearable
        control={control}
        name="typeOfCommute"
        options={TYPE_OF_COMMUTE_OPTIONS}
        label="Type of Commute"
      />
      <Select
        isClearable
        control={control}
        name="commuteTime"
        options={COMMUTE_TIME_OPTIONS}
        label="Commute Time"
      />
      <Select
        isClearable
        control={control}
        name="cancellationPolicy"
        options={CANCELLATION_POLICY_OPTIONS}
        label="Cancellation Policy"
      />

      <Select
        isClearable
        control={control}
        name="inHouseCancellation"
        options={IN_HOUSE_CANCELLATION_OPTIONS}
        label="In-House Cancellation"
      />
      <Select
        isClearable
        control={control}
        name="monthToMonthLease"
        options={MONTH_TO_MONTH_LEASE_OPTIONS}
        label="Month to Month Lease"
      />
      <Select
        isClearable
        control={control}
        name="sortType"
        options={sortOptions.map((option) => ({
          label: option.title,
          value: option.value,
        }))}
        label="Priority for this Request"
      />
      <ToggleAndDescription
        toggleFormField="airportTransferChecked"
        toggleLabel={
          isRiverside ? 'Taxi Required' : 'Airport Transfer Required'
        }
      >
        <Select
          rules={{
            required: airportTransferChecked
              ? errorMessages.airportTransfer
              : false,
          }}
          error={errors.airportTransfer}
          isClearable
          control={control}
          name="airportTransfer"
          options={AIRPORT_TRANSFER_OPTIONS}
          label="Paid by *"
        />
        <TextInput
          {...register('airportTransferInformation')}
          label={isRiverside ? 'Pick up Address' : 'Flight Information'}
        />
      </ToggleAndDescription>
      {shouldShowWelcomePack && (
        <ToggleAndDescription
          toggleFormField="welcomePackRequired"
          textAreaFormField="welcomePackDescription"
          toggleLabel="Welcome Pack Required"
          textAreaPlaceholder="Specify welcome pack budget, description etc"
        />
      )}
      <TextArea
        {...register('message')}
        error={errors.message}
        label="Additional Comments"
        placeholder="Any additional information or requirements related to this request"
        hint={
          'Comments will be visible to Altovita and activated users (clients) but not on the public property links.'
        }
      />
    </FormSection>
  )
}
